import { get } from './api';

export const downloadedPdfUsersApi = {
    getDownloadedPdfUsers() {
        return get('admin/users/pdf-downloads');
    }
};
